var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100 w-100 px-0 position-absolute"
  }, [_c('div', {
    staticClass: "h-100 w-100 overflow-auto"
  }, _vm._l((_vm.getMessages), function(message, index) {
    return _c('Message', {
      key: index,
      attrs: {
        "message": message,
        "index": index,
        "active": _vm.active
      },
      on: {
        "changeMessage": _vm.changeMessage
      }
    })
  }), 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-735ba8ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Messaging/Messages.vue
// module id = B2C+
// module chunks = 2